
export default defineNuxtPlugin((nuxtApp) => {
    const route = useRoute()

    nuxtApp.vueApp.directive('log', {
        mounted (el, binding) {
            const options = binding.value

            if (!options) {
                return
            }

            if (!options.event) {
                options.event = 'click'
            }

            el.setAttribute('data-log', JSON.stringify(options))

            const handler = () => {
                const dataLog = JSON.parse(el.getAttribute('data-log'))

                const data = {
                    event: dataLog.event ?? 'click',
                    label: dataLog.label ?? '',
                    data: dataLog.data ?? '',
                    json_data: dataLog.jsonData ?? '',
                    route: route.path
                }

                nuxtApp.$axios.post('/be/log', data).then(() => {})
            }

            el.addEventListener(options.event, handler, true)
            el._logHandler = handler
            el._logEvent = options.event
        },
        updated (el, binding) {
            el.setAttribute('data-log', JSON.stringify(binding.value))
        },
        unmounted (el) {
            if (el._logHandler && el._logEvent) {
                el.removeEventListener(el._logEvent, el._logHandler, true)
            }
        }
    })
})
